import compact from "lodash/compact";
import uniq from "lodash/uniq";
import LibrarianType from "types/LibrarianType";
import UserType from "types/UserType";

export default function librarianRolesForUser(user: UserType) {
  let roles = user.librarianRoles;
  if (user.admin) {
    roles = ["admin", "appender", "editor", "librarian"];
  } else if (user.pro) {
    roles = uniq([
      ...roles,
      ...["appender", "editor", "librarian"],
    ]) as LibrarianType[];
  }
  return compact(roles);
}
